import { Flex, Menu, Text, Tooltip } from "@mantine/core";
import type { TablerIcon } from "@tabler/icons-react";

export function SquareIconMenuButton({
  id,
  parentId,
  label,
  icon,
  tooltip,
  color,
  onClick,
  isActive = false,
  disabled = false,
}: {
  id: string;
  parentId?: string;
  label: string;
  icon: TablerIcon;
  tooltip: string;
  color?: string;
  onClick: (actionId: string, parentId?: string) => void;
  isActive?: boolean;
  disabled?: boolean;
}) {
  const Icon = icon;
  const iconColor =
    color ?? (isActive ? "var(--mantine-color-dark-6)" : undefined);
  const labelWeight = isActive ? 500 : 400;
  const labelColor = isActive ? "var(--mantine-color-dark-6)" : undefined;
  const buttonColor = isActive ? "#F0F2F6" : undefined;
  const menuItemColor = disabled
    ? "var(--mantine-color-gray-6)"
    : "var(--mantine-color-dark-6)";

  function onClickHandler() {
    if (disabled) return;
    onClick(id, parentId);
  }

  return (
    <Tooltip
      offset={0}
      openDelay={500}
      label={tooltip}
      position="bottom"
      withArrow
    >
      <Menu.Item
        px={0}
        c={menuItemColor}
        color="var(--mantine-color-gray-2)"
        variant="white"
        h={60}
        onClick={onClickHandler}
        bg={buttonColor}
        opacity={disabled ? 0.6 : 1}
      >
        <Flex direction="column" align="center" justify="center" gap={4}>
          <Icon stroke={1.2} size={22} color={iconColor} />
          <Text fw={labelWeight} fz={13} c={labelColor}>
            {label}
          </Text>
        </Flex>
      </Menu.Item>
    </Tooltip>
  );
}
